import React, { useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import classNames from 'classnames';
import { selectDrawerOptions } from '@/store/ui/selectors';
import { Drawer } from '@/store/ui/reducers';
import { closeDrawer } from '@/store/ui/actions';

function DrawerContainer() {
  const [isDrawerOpen, setIsDrawerOpen] = React.useState(false);

  const { isOpen, drawerName } = useSelector(selectDrawerOptions);
  const dispatch = useDispatch();

  const DrawerComponent = drawerName ? Drawer[drawerName] : null;

  // Used to stop scrolling when drawer is open
  useEffect(() => {
    if (isOpen) {
      document.body.classList.add('overflow-hidden');
    } else {
      document.body.classList.remove('overflow-hidden');
    }

    return () => {
      document.body.classList.remove('overflow-hidden');
    };
  }, [isOpen]);

  useEffect(() => {
    // Needs to be run with timeout so underlying drawer components don't stop opening animation
    // Menu drawer has MenuDrawerUser component which bugs out the animation when opening, and
    // makes it seem as it instantly appears for authenticated users. Closing animation stays okay,
    // adding this change ammends that.
    setTimeout(() => setIsDrawerOpen(isOpen), 0);
  }, [isOpen]);

  function closeDrawerFunction() {
    setIsDrawerOpen(false);
    setTimeout(() => {
      dispatch(closeDrawer());
    }, 250);
  }

  if (!DrawerComponent) {
    return null;
  }

  return (
    <div className="fixed inset-0 z-[200]">
      <div
        className={classNames(
          'w-full h-full md:bg-black/75 relative overflow-scroll overscroll-none no-scrollbar',
          'md:transition-opacity md:duration-200 md:ease-in-out',
          {
            'md:opacity-100': isDrawerOpen,
            'md:opacity-0': !isDrawerOpen,
          },
        )}
      >
        <div className="absolute z-[1] inset-0" onClick={closeDrawerFunction} />
        <div
          className={classNames(
            'absolute right-0 transition-all duration-300 ease-in-out h-full w-full md:w-auto z-[2]',
            {
              'translate-x-0': isDrawerOpen,
              'translate-x-full': !isDrawerOpen,
            },
          )}
        >
          <DrawerComponent closeDrawer={closeDrawerFunction} />
        </div>
      </div>
    </div>
  );
}

export default DrawerContainer;
